import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import React, { PropsWithChildren, ReactElement } from "react";

import TrashIcon from "../../icons/outlines/trash";

export const CanvasElementMenuItemHeight = 32; // Height of each menu item in pixels
export const CanvasElementMenuWidth = 40; // Width of the menu in pixels

export function CanvasElementMenuItemDelete({
  onDelete,
}: {
  onDelete: () => void;
}): ReactElement {
  return (
    <MenuItem
      onClick={() => onDelete()}
      className="h-[30px] !justify-center !border-b-[1px] !border-solid !border-slate-300 !p-[5px]"
    >
      <TrashIcon className="!text-[20px]" />
    </MenuItem>
  );
}

export function CanvasElementMenuItemMoveUp({
  onMoveUp,
}: {
  onMoveUp: () => void;
}): ReactElement {
  return (
    <MenuItem
      onClick={() => onMoveUp()}
      className="h-[30px] !justify-center !border-b-[1px] !border-solid !border-slate-300 !p-0"
    >
      <MoveUpIcon className="!text-[20px]" />
    </MenuItem>
  );
}

export function CanvasElementMenuItemMoveDown({
  onMoveDown,
}: {
  onMoveDown: () => void;
}): ReactElement {
  return (
    <MenuItem
      onClick={() => onMoveDown()}
      className="h-[30px] !justify-center !border-t-[1px] !border-solid !border-slate-300 !p-0"
    >
      <MoveDownIcon className="!text-[20px]" />
    </MenuItem>
  );
}

export function CanvasElementMenuItemDuplicate({
  onDuplicate,
}: {
  onDuplicate: () => void;
}): ReactElement {
  return (
    <MenuItem
      onClick={() => onDuplicate()}
      className="h-[30px] !justify-center !border-t-[1px] !border-solid !border-slate-300 !p-[5px]"
    >
      <ContentCopyIcon className="!text-[20px]" />
    </MenuItem>
  );
}

export function CanvasElementMenu(
  props: {
    position: { x: number; y: number };
  } & PropsWithChildren,
): ReactElement {
  const { position, children } = props;

  return (
    <Paper
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
      className="absolute top-[50%] z-50 w-[40px] cursor-pointer bg-white"
    >
      <MenuList>{children}</MenuList>
    </Paper>
  );
}
